var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon",class:_setup.classIcon,on:{"click":function($event){return _setup.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }